import React, { Component } from 'react';
import { withTranslation } from "react-i18next";


class HostelInfoNoTranslation extends Component {
  static propTypes = {

  };

  render() {
    const { t } = this.props;
    return (
      <div className="common-hostel-info">
        <div className="hostel-info">
          <p className="contact-text"><b >{t('general.hostelInfoPhone', { framework: 'React' })}</b><br /> <i><a href="tel://+34 633229424">+34 633229424</a></i><br /><i><a href="tel://+34696857832">+34 696857832</a></i></p>
          <a href="mailto:oripandohostel@gmail.com"><i>oripandohostel@gmail.com</i></a>
        </div>
      </div>
    );
  }
}


const HostelInfo = withTranslation('common')(HostelInfoNoTranslation)

export default HostelInfo;


// WEBPACK FOOTER //
// ./src/features/common/HostelInfo.js